import { combineReducers } from 'redux';
import { formFields, formFieldFetches } from './formFields';
import { profile, profileFetches } from './profile';
import { buyer } from './buyer';
import { vendor } from './vendor';

const entities = combineReducers({
  formFields,
  profile,
  buyer,
  vendor,
});

const fetches = combineReducers({
  formFields: formFieldFetches,
  profile: profileFetches,
});

const rootReducer = combineReducers({
  entities,
  fetches
});

export default rootReducer;
